// components/pricing/PricingCard/styles.js
import styled from "styled-components";
import { motion } from "framer-motion";
import { Button } from "../../../styles/components";

export const PeriodBadge = styled.div`
    margin-top: ${props => props.theme.spacing.md};
    padding: ${props => props.theme.spacing.xs} ${props => props.theme.spacing.sm};
    border-radius: ${props => props.theme.borderRadius.full};
    font-size: ${props => props.theme.typography.sizes.sm};
    text-align: center;
    background: ${props => {
        switch (props.interval) {
            case 'quarterly':
                return props.theme.colors.success.main + '20';
            case 'bimonthly':
                return props.theme.colors.warning.main + '20';
            default:
                return props.theme.colors.primary.main + '20';
        }
    }};
    color: ${props => {
        switch (props.interval) {
            case 'quarterly':
                return props.theme.colors.success.main;
            case 'bimonthly':
                return props.theme.colors.warning.main;
            default:
                return props.theme.colors.primary.main;
        }
    }};
`;

export const Card = styled(motion.div)`
	background: white;
	border-radius: ${(props) => props.theme.borderRadius.lg};
	padding: ${(props) => props.theme.spacing.xxl};
	position: relative;
	height: 100%;
	display: flex;
	flex-direction: column;
	transition: transform 0.3s ease;
	border: 2px solid transparent;

	${(props) =>
		props.isPopular &&
		`
        border-color: ${props.theme.colors.primary.main};
        transform: scale(1.05);

        @media (max-width: ${props.theme.breakpoints.lg}) {
            transform: scale(1);
        }
    `}

	&:hover {
		transform: translateY(-5px);
	}

	${(props) =>
		props.disabled &&
		`
        opacity: 0.7;
        pointer-events: none;
    `}
`;

export const PopularBadge = styled.div`
	position: absolute;
	top: -15px;
	left: 50%;
	transform: translateX(-50%);
	background: ${(props) => props.theme.colors.primary.main};
	color: white;
	padding: 8px 24px;
	border-radius: 100px;
	font-weight: 500;
	font-size: ${(props) => props.theme.typography.sizes.sm};
`;

export const PlanName = styled.h3`
	font-size: ${(props) => props.theme.typography.sizes["2xl"]};
	color: ${(props) => props.theme.colors.text.primary};
	margin-bottom: ${(props) => props.theme.spacing.md};
	text-align: center;
`;

export const PriceContainer = styled.div`
    text-align: center;
    margin: ${props => props.theme.spacing.lg} 0;

    .price {
        display: flex;
        align-items: baseline;
        justify-content: center;
        gap: ${props => props.theme.spacing.xs};
    }

    .currency {
        font-size: ${props => props.theme.typography.sizes.xl};
        color: ${props => props.theme.colors.text.primary};
    }

    .amount {
        font-size: ${props => props.theme.typography.sizes["4xl"]};
        font-weight: ${props => props.theme.typography.weights.bold};
        color: ${props => props.theme.colors.text.primary};
    }

    .interval {
        font-size: ${props => props.theme.typography.sizes.sm};
        color: ${props => props.theme.colors.text.secondary};
    }
`;
export const Description = styled.p`
	text-align: center;
	color: ${(props) => props.theme.colors.text.primary};
	margin-bottom: ${(props) => props.theme.spacing.xl};
	font-size: 18px;
`;

export const FeatureSection = styled.div`
	margin-bottom: ${(props) => props.theme.spacing.xl};

	h4 {
		color: ${(props) => props.theme.colors.text.primary};
		font-size: 16px;
		font-weight: 600;
		margin-bottom: ${(props) => props.theme.spacing.sm};
		/* text-transform: uppercase; */
	}
`;

export const FeatureList = styled.ul`
	list-style: none;
	padding: 0;
	margin: 0;

	li {
		display: flex;
		align-items: center;
		margin-bottom: ${(props) => props.theme.spacing.sm};
		color: ${(props) => props.theme.colors.text.primary};
		font-size: 15px;
		svg {
			color: ${(props) => props.theme.colors.success.main};
			margin-right: ${(props) => props.theme.spacing.sm};
			flex-shrink: 0;
		}
	}
`;

export const StyledButton = styled(Button)`
	width: 100%;
	margin-top: auto;
	padding: ${(props) => props.theme.spacing.md};
`;

export const CreditHighlight = styled.div`
	background: ${(props) => props.theme.colors.primary.light}20;
	padding: ${(props) => props.theme.spacing.lg};
	border-radius: ${(props) => props.theme.borderRadius.md};
	margin: ${(props) => props.theme.spacing.md} 0;
	text-align: center;

	h4 {
		font-size: ${(props) => props.theme.typography.sizes["2xl"]};
		color: ${(props) => props.theme.colors.primary.dark};
		margin-bottom: ${(props) => props.theme.spacing.xs};
	}

	p {
		font-size: ${(props) => props.theme.typography.sizes.md};
		color: ${(props) => props.theme.colors.text.primary};
		margin-bottom: ${(props) => props.theme.spacing.sm};
	}

	span {
		font-size: ${(props) => props.theme.typography.sizes.sm};
		color: ${(props) => props.theme.colors.text.secondary};
	}
`;
